import { hasPermission } from "../../Config/permissions.js";

const AS_USER_TYPES = new Set(["Admin", "ASD", "Authorizer", "Viewer"]);

export const canAccessManufacturerCommissionContract = (user, contractId) => {
  if (!user || !AS_USER_TYPES.has(user.Type)) return false;

  return hasPermission(
    user,
    contractId ? "mfr_contract.view" : "mfr_contract.edit",
  );
};
